import { cn } from '@pickleballinc/ui/lib/utils';

export function Path({ active, isOrange }: { active: boolean; isOrange?: boolean }) {
	return (
		<div
			className={cn('flex-1 transition-all h-0.5 bg-gray-200', {
				'bg-darkorange-600': active && isOrange,
				'bg-experiment': active && !isOrange
			})}
		/>
	);
}
